import { Component, Output, EventEmitter, Input, ViewChild, OnDestroy, QueryList, ViewChildren, OnChanges, Renderer2, ElementRef, OnInit } from '@angular/core';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { SopDetail } from '../Models/SopDetail';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { PhpBhpChartExportComponent } from '../php-bhp-chart-export/php-bhp-chart-export.component';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { PHBHPFeaturePackageEvaluationFilterService } from '../ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from '../ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { Router } from '@angular/router';
import { PhBhpBarChartComponent } from '../ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'lib-ph-bhp-sop-substep-compliance',
  templateUrl: './ph-bhp-sop-substep-compliance.component.html',
  styleUrls: ['./ph-bhp-sop-substep-compliance.component.css']
})
export class PhBhpSopSubstepComplianceComponent implements OnInit, OnChanges, OnDestroy {
  private static readonly INITIAL_FIELDS = [
    { 'field': 'stepName', 'title': 'EVALUATION.STEP_NAME' },
  ];
  pageTitle: string;
  textLegend: string;
  langSubscription: Subscription;
  compareCard;
  subProcess: boolean = false;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  @Input() filterDetails
  @Input() userData;
  @Input() isDesktop = true;
  @Output() childData = new EventEmitter();
  public chart: PhBhpBarChartComponent;

  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;

  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterComponent;
  @ViewChild('exportTag') export: PhpBhpChartExportComponent;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  initFlag = true;
  enableSubprocess: boolean = false;
  item: any;
  subStepAnotherArra: Array<any> = [];
  isSubStepProcessSOP = false;
  sopDetail: SopDetail[];
  selectedSopID: string = "";
  selectedSopTitle: string = "";
  selectedStepTypeValue = 0;
  selectedStepTypeName: string = "";
  selectedSpecificStepName: string = "";
  enableSpecificSteps: boolean = false;
  isAdjustableHeight = true;
  appName = 'MHS';
  gridData: Array<any>;
  stepTypesEnabled = true;
  fields: any[] = [...PhBhpSopSubstepComplianceComponent.INITIAL_FIELDS];
  roleId: any;
  userID
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  complianceType
  specificStep: Array<any> = [];
  selectedSpecificStep: Array<any> = [];
  apiData: any;
  benchmarkLegend = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  filterIndices: number[] = [0];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  selectedSopSubProcess: any;
  selectedSopSubProcessName: string = '';
  sopSubProcess: Array<any> = [];
  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;
  evaluationLoaded: boolean = false;
  hasSubSteps: boolean = false;

  results:any = [];
  userFilters: any;
  sopFilters: any[] = [];
  multiSelectText: string = '';
  originalSopSteps: Array<any> = [];

  originalFields: any[] = null;
  selectedSeries: Set<number> = new Set();

  evaluateSingleFilter: string = '';
  colors = [
    "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300",
  ];

  constructor(
    private el: ElementRef, private renderer: Renderer2,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService,
    public router: Router) {
    this.pageTitle = this.layoutService.translateText('EVALUATION.SUB_STEP_COMPLIANCE');
    this.textLegend = this.layoutService.translateText("EVALUATION.PERCENT_COMPLIANCE");
  }

  ngOnInit(): void {

    this.userID = this.userData.userId;
    this.roleId = this.userData.roleName.roleId;

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.evaluate(true);
    });
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.evaluationService.getSOPDetails(this.userData.userId).subscribe((res: Array<SopDetail>) => {
      this.userHasFilter = false;
      this.sopDetail = res;
      this.sopDetail = this.sopDetail.sort((a, b) => this.compareSOPTitles(a, b));
      // this.onSopChange(this.sopDetail[0].sopid, true)
      this.selectedSopID = this.sopDetail[0].sopid.toString();
      this.selectedSopTitle = this.sopDetail[0].title;
      this.selectedStepTypeName = this.layoutService.translateText('EVALUATION.All.STEPS');
      if (!this.isUserFilterSetted) {
        this.evaluationService.getUserHasSOPEvaluationFilter(this.userData.userId, 'Sub-step compliance').subscribe((userHasFilter) => {
          this.isUserFilterSetted = true;
          if(userHasFilter){
            this.userHasFilter = true;
            this.userFilters = JSON.parse(userHasFilter.filterList);
            this.userFilters = this.userFilters.Filter;
            setTimeout(() => { this.initComponent(); });
          }else{

            this.onSopChange(this.sopDetail[0]);
            this.userFilters = [];
            this.noDataFound = true;
            this.filters.get(0).showFilter(true);
            this.compliance.resultsLoader.next([{}]);
          }
        }, (error) => { }, () => { this.layoutService.showLoader = false; });
      } else {
        setTimeout(() => { this.initComponent(true); });
      }
    });
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
  }

  initComponent(isNewFilter = false) {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.userData) {
      for(let i = 0; i < this.charts.length; i++){
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title.text = this.textLegend;
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';

      this.loadFiltersInfo();

      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      if(this.userFilters.length > 0){
        this.onSopChange(this.sopDetail.find(res => res.sopid == parseInt(this.userFilters[0].sopIds)), true);
      }

      this.evaluate(true, {}, true);
    }
  }


  onSopChange(sop, isManualChange = false) {

    if(!sop){
      sop = this.sopDetail[0];
    }

    if (!sop || sop.sopStepsVersions.length == 0) {
      return;
    }

    let stepsJsonFile = JSON.parse(sop.sopStepsVersions[0].stepsJsonFile);
    this.originalSopSteps = stepsJsonFile;
    const isSubStepProcess = this.isSubStepProcessSOP;
    this.isSubStepProcessSOP = false;
    this.specificStep = [];
    this.sopSubProcess = [];
    this.selectedSpecificStep = [];
    stepsJsonFile.forEach((res) => {
      this.specificStep = this.specificStep.concat(res.stepCards);
      if (res.stepName !== '') {
        this.isSubStepProcessSOP = true;
      }

      if (res.stepCards.length > 1) {
        this.sopSubProcess.push(res);
      }
    });

    this.onSelectedSopSubProcess(0, true);
    if (this.isSubStepProcessSOP !== isSubStepProcess) {
      this.onStepLevelFilterChanges(0);
    }
    if(!isManualChange){
      this.evaluate(true);
    }
  }

  onSizeChange(value) {

  }

  compareSOPTitles(a, b) {
    var aTitleTranslated = this.getSOPTranslation(a.title);
    var bTitleTranslated = this.getSOPTranslation(b.title);
    if (aTitleTranslated < bTitleTranslated) return -1;
    if (aTitleTranslated > bTitleTranslated) return 1;
    return 0;
  }

  getSOPList(id, roleId, isNewFilter = false) {
    const sopDetailList: Observable<Array<SopDetail>> = this.evaluationService.getSOPDetails(id)
    const subStepAndFrequency = this.evaluationService.getSubStepAndFrequencyComplianceDetails(id, roleId, true, false, this.subProcess)
    this.layoutService.showLoader = true;
    forkJoin([sopDetailList, subStepAndFrequency]).subscribe(([sopDetailRes, subStepAndFrequencyRes]) => {
      this.layoutService.showLoader = false;
      this.sopDetail = sopDetailRes;
      this.sopDetail = this.sopDetail.sort((a, b) => this.compareSOPTitles(a, b));
      this.onSopChange(this.sopDetail[0].sopid, true)
      this.selectedSopID = this.sopDetail[0].sopid.toString();
      this.selectedSopTitle = this.sopDetail[0].title;
      this.selectedStepTypeName = this.layoutService.translateText('EVALUATION.All.STEPS');
      if (!isNewFilter) {
        if (this.filterDetails.length > 0) {
          this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
          this.evaluate(true);
        } else {
          this.subStepProcessComplianceRes(subStepAndFrequencyRes);
        }
      }
    }, (error) => { this.layoutService.showLoader = false; });
  }

  getSOPTranslation(sopTrlID) {
    return this.layoutService.translateText(sopTrlID, '');
  }

  getSubStepAndFrequencyComplianceDetails(userID, roleId) {
    this.layoutService.showLoader = true;
    this.evaluationService.getSubStepAndFrequencyComplianceDetails(userID, roleId, true, false, this.subProcess).subscribe((res) => {
      this.subStepProcessComplianceRes(res);
    })
  }

  subStepProcessComplianceRes(res) {

    if (res.subStepProcessComplianceMainList == null) {
      this.noDataFound = true;
      this.chart.noDataFound = true;
      this.layoutService.showLoader = false;
    } else {
      this.apiData = res.subStepProcessComplianceMainList;
      let sopFilters = res.sopFilters;
      if (sopFilters && sopFilters.length > 0 && sopFilters[0].filter && sopFilters[0].filter.length > 0) {
        this.filterIndices = sopFilters[0].filter.map((_, index) => index);
      }

      if (sopFilters && sopFilters.length > 0) {
        let filterValue = sopFilters[0];
        this.selectedSopID = filterValue.sopiDs;
        this.selectedSopTitle = this.sopDetail.find(res => res.sopid == parseInt(this.selectedSopID)).title;
        this.selectedStepTypeValue = filterValue.stepType;
        this.setStepTypeNameByValue(res, this.selectedStepTypeValue);
        this.onSopChange(this.selectedSopID, true)
        if (filterValue.selectedSteps && this.selectedStepTypeValue == 2) {
          this.selectedSpecificStep = filterValue.selectedSteps;
        }
        this.filters.toArray().forEach((filterComponent, index) => {
          if (sopFilters[0].filter[index]) {
            let startDate = new Date(sopFilters[0].filter[index].startDate);
            startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
            let endDate = new Date(sopFilters[0].filter[index].endDate);
            endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
            filterComponent.dateRange = [startDate, endDate];
            filterComponent.selectDate();
            filterComponent.setCountryFilter(sopFilters[0].filter[index].countryID, sopFilters[0].filter[index].instutionIDs, sopFilters[0].filter[index].wardID, true);
            filterComponent.setDepartmentFilter(sopFilters[0].filter[index].departmentID, true);
            filterComponent.setDepartmentTypeFilter(sopFilters[0].filter[index].departmentTypeID, true);
            filterComponent.setProfessionalCategory(sopFilters[0].filter[index].professionalCategoryID, sopFilters[0].filter[index].subprofessionalCategoryID, true);
          }
        });
        setTimeout(() => {
          this.compliance.setFilters(this.filters.toArray());
          this.evaluate(true);
        }, 1000)

        this.printConfig();

        if (sopFilters[0].filter.length >= 2 && this.isDesktop) {
          this.showCompareCard = this.filterIndices.length > 1;
          this.compliance.showCompareCard = this.showCompareCard;
          this.tempFilter = sopFilters[0];
        }
      }
    }
    this.evaluationLoaded = true;
    this.layoutService.showLoader = false;
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      let tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  emitData(valve) {
    this.childData.emit(valve)
  }

  filterCompare() {
    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }

    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
      this.layoutService.showLoader = false;
    }, 500);
  }

  printConfig() {
    var selectedSop = this.sopDetail.find(res => res.sopid == parseInt(this.selectedSopID));
    if (!selectedSop) return;
    this.compliance.SOPName = this.compliance.SOPName = this.sopDetail.find(res => res.sopid == parseInt(this.selectedSopID)).title;
    if (this.selectedStepTypeValue == 0) {
      this.compliance.Steps = this.layoutService.translateText('EVALUATION.All.STEPS');
      this.compliance.specificStep = undefined;
      this.selectedSpecificStep = [];
    } else if (this.selectedStepTypeValue == 1) {
      this.compliance.Steps = this.layoutService.translateText('EVALUATION.HYGIENE_RELEVANT_STEPS');
      this.compliance.specificStep = undefined;
      this.selectedSpecificStep = [];
    } else {
      this.compliance.Steps = this.layoutService.translateText('EVALUATION.SPECIFIC_STEPS');
      this.compliance.specificStep = this.selectedSpecificStep;
    }
  }

  selectedSopDetail() {
    if (this.sopDetail) {
      var newSOP = Object.assign({}, this.sopDetail.find(res => res.sopid == parseInt(this.selectedSopID)));
      if (!this.subProcess)
        newSOP.title = newSOP.title + " ( " + this.layoutService.translateText('EVALUATION.WITHOUT_SUB_PROCESS') + " )"
      return newSOP;
    }

  }

  evaluate(getResults, resultSet?, iniatilize?) {

    this.printConfig();

    this.data = {
      sopiDs: this.selectedSopID,
      selectedSteps: resultSet?.selectedSpecificStep || this.specificStep,
      filter: [],
      isBenchMark: true,
      isHygieneOnly: false,
      stepType: resultSet?.selectedStepTypeValue || this.selectedStepTypeValue,
      roleId: this.roleId
    }

    if (this.selectedSopID == "") {
      this.sopDetail.forEach((sop) => {
        this.data.sopiDs += sop.sopid + ","
      });
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    }

    if(iniatilize){
      this.data.filter = this.userFilters;
    }else{
      this.filters.forEach((filter) => {
        let filterData:any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0,
          sopIds: this.data.sopiDs
        };
        if (this.userData.roleName.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if(filterData.multiSelectName){
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.userHasFilter = true;
    if (getResults == true) {
      this.getSubStepComplianceFilterDetails(this.userID, this.data);
    }
    else if (getResults == false) {
      this.saveSubStepComplianceFilterDetails(this.userID, this.data);
    }
  }

  getSubStepComplianceFilterDetails(userID, data) {
    this.complianceType = "Sub-step compliance";
    this.isSavedFromEvaluation = true;
    var type = false;
    this.layoutService.showLoader = true;
    this.evaluationService.getSubStepAndFrequencyComplianceFilterDetails(userID, type, this.isSavedFromEvaluation, this.complianceType, data, this.subProcess).subscribe(res => {
      this.apiData = res;
      this.buildChart(res);
    })
  }

  saveSubStepComplianceFilterDetails(userID, data) {
    this.complianceType = "Sub-step compliance";
    this.isSavedFromEvaluation = false;
    var type = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.getSubStepAndFrequencyComplianceFilterDetails(userID, type, this.isSavedFromEvaluation, this.complianceType, data, this.subProcess).subscribe(res => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText('EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT'));
    })
  }

  buildChart(res) {
    this.compliance.subStepDetail = this.subProcess;
    this.fields = [...PhBhpSopSubstepComplianceComponent.INITIAL_FIELDS];

    let chart: PhBhpBarChartComponent;

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    if(this.evaluateSingleFilter){
      res = res.filter(res => res.filterType == this.evaluateSingleFilter || (this.evaluateSingleFilter == 'single' && !res.filterType));
    } else {
      this.results = [];
      res.forEach(result => {
        if(result.subStepProcessComplianceResultList.length > 0){
          let id = result.filterType || 'single';
          if(this.results.findIndex(r => r.id === id) === -1){
            this.results.push({ id, subStepProcessComplianceResultList: [], fields:[], gridData:[], noDataFound: true });
          }
        }
      });
    }

    this.compliance.resultsLoader.next(Object.assign([], this.results));

    setTimeout(() => {
      res.forEach((subSetComplianceArray: any, index) => {
        let firstSubSetComplianceArrayWithData = res.find(subSetComplianceArray => subSetComplianceArray.subStepProcessComplianceResultList &&
          subSetComplianceArray.subStepProcessComplianceResultList.length > 0);

        let chartId = subSetComplianceArray.filterType || 'single';
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        let result = this.results[chartIndex];
        chart = this.charts.get(chartIndex);

        if(this.specificStep){
          result.specificStep = this.specificStep;
        }

        if(!result.colors){
          result.colors = [];
        }
        if(!result.keepColors){
          result.colors.push(this.colors[index]);
        }

        let data = JSON.parse(JSON.stringify(chart.chartOptions));
        let dataSet = 0;
        let dataSetsName = this.layoutService.translateText('EVALUATION.DATA_SETS');

        if(!data.setId || this.evaluateSingleFilter){
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
          this.evaluateSingleFilter = '';
        }

        dataSet = 0;
        data.series[data.nextIndex] = { data: [], name: [], dataOffset:[] , serieIndex: index};
        data.seriesIdentifier[data.nextIndex] = [];
        data.series[data.nextIndex].color = result.keepColors ? result.colors[index] : this.colors[index];
        chart.chartId = chartId;

        if (this.selectedSopSubProcess.stepName != 'EVALUATION.All.MAIN_STEPS') {
          var specificStepIds = this.selectedSopSubProcess.stepCards?.map(res => res.stepCardId);
          if (this.selectedSpecificStep[0] && this.selectedSpecificStep[0].stepTittle != 'EVALUATION.All.SOP_STEPS') {
            var selectedStep = this.selectedSpecificStep[0];
            subSetComplianceArray.subStepProcessComplianceResultList = subSetComplianceArray.subStepProcessComplianceResultList.filter(step => selectedStep.stepCardId == step.stepCardId);
          }
        }

        if (!subSetComplianceArray.subStepProcessComplianceResultList?.every(c=> c.noData)) {
          this.results[chartIndex].noDataFound = false;
          this.noDataFound = false;
          chart.noDataFound = false;
        }

        const nameCountMap = new Map();
        subSetComplianceArray.subStepProcessComplianceResultList.forEach((subSetCompliance: any) => {
          subSetCompliance.list.forEach((subSetComplianceItem: any) => {
            const name = this.layoutService.translateText(subSetComplianceItem.stepName);
            if (nameCountMap.has(name)) {
              nameCountMap.set(name, nameCountMap.get(name) + 1);
            } else {
              nameCountMap.set(name, 1);
            }
          });
        });

        const nameIndexMap = new Map();

        subSetComplianceArray.subStepProcessComplianceResultList.forEach((subSetCompliance: any, i) => {
          this.benchmarkLegend = true;
          if (subSetCompliance.isSubStep) {
            this.subProcess = true;
          }
          let subSetComplianceDataSet = subSetCompliance;
          data.series[data.nextIndex].dataSetId = subSetComplianceDataSet.id;

          subSetCompliance.list.forEach((subSetComplianceItem: any, i) => {
            if (this.selectedStepTypeValue == 0 ||
              (this.selectedStepTypeValue == 1 && firstSubSetComplianceArrayWithData && firstSubSetComplianceArrayWithData.subStepProcessComplianceResultList.length > 0 &&
                firstSubSetComplianceArrayWithData.subStepProcessComplianceResultList[i].isHygiene) ||
              (this.selectedStepTypeValue == 2)) {
                if (dataSet == 0) {
                  dataSet = subSetComplianceItem.totalObservations;
                }
              let compliancePercentage = (subSetCompliance.noData && subSetComplianceItem.processCompliancePercentage == 0) ? 'NODATA' : subSetComplianceItem.processCompliancePercentage;

              this.subSetComplianceStepName(subSetComplianceItem, "OBSERVATION.BEFORE.TOUCHING_PATIENT"); //Before touching a patient
              this.subSetComplianceStepName(subSetComplianceItem, "OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1"); //"Before aseptic procedures");
              this.subSetComplianceStepName(subSetComplianceItem, "OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK"); //"After body fluid exposure risk");
              this.subSetComplianceStepName(subSetComplianceItem, "OBSERVATION.AFTER.TOUCHING_PATIENT"); //"After touching a patient");
              this.subSetComplianceStepName(subSetComplianceItem, "OBSERVATION.AFTER.TOUCHING_SURROUNDINGS"); //"After touching patient surroundings");

              const name = this.layoutService.translateText(subSetComplianceItem.stepName);
              if (nameCountMap.get(name) > 1) {
                if (!nameIndexMap.has(name)) {
                  nameIndexMap.set(name, 1);
                }
                const index = nameIndexMap.get(name);
                subSetComplianceItem.stepName = name + ' ' + index.toString();
                nameIndexMap.set(name, index + 1);
              } else {
                subSetComplianceItem.stepName = name;
              }

              data.series[data.nextIndex].data.push(compliancePercentage);
              data.series[data.nextIndex].dataOffset.push({id: subSetComplianceItem.stepName, setId: subSetComplianceDataSet.id, value: compliancePercentage});
              data.seriesIdentifier[data.nextIndex].push({id: subSetComplianceItem.stepName, setId: subSetComplianceDataSet.id});

              let title = subSetComplianceItem.stepName;
              if(subSetComplianceDataSet.id >= 0 && subSetComplianceDataSet.name){
                title += " / " +this.layoutService.translateText(subSetComplianceDataSet.name);
              }
              title = title ? title : subSetComplianceItem.stepName;
              if(subSetComplianceItem.isHygiene){
                title = "* " + title;
              }
              if (!data.categoryAxis.categories.includes(title)) {
                data.categoryAxis.categories.push(title);
                data.categoryAxis.categoryOffset.push({id: subSetComplianceItem.stepName, setId: subSetComplianceDataSet.id});
              }
            }
          })
        });

        let maxLength =  data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }

        data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[data.series[data.nextIndex].serieIndex] ? this.data.filter[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)} - ${dataSet} ${dataSetsName}`];
        data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[data.series[data.nextIndex].serieIndex] ? this.data.filter[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (data.series[data.nextIndex].serieIndex + 1)}`];
        data.series[data.nextIndex].filterNum = data.series[data.nextIndex].serieIndex+1;

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let firstSet = subSetComplianceArray.subStepProcessComplianceResultList;
        let resultSet: any[] = [];
        if(firstSet.length > 0 && firstSet[0].list?.length > 0){
          firstSet[0].list.forEach(item => {
            let title = this.layoutService.translateText(item.title);
            resultSet.push({ ...item, title });
          });
        }

        this.results[chartIndex].resultChart = chart;
        this.compliance.resultsLoader.next(Object.assign([], this.results));
        if (!this.results[chartIndex].tabName) {
          this.results[chartIndex].tabName = '';
        }

        var tabNames = this.results[chartIndex].tabName.split(",").filter((value) => value !== '');
        const filterObj = this.data.filter && this.data.filter[data.series[data.nextIndex - 1].serieIndex];
        if (filterObj && filterObj.filterName && filterObj.filterName.trim() !== '') {
            tabNames.push(filterObj.filterName);
        } else {
            tabNames.push(`EVALUATION.FILTER${data.series[data.nextIndex - 1].serieIndex + 1}`);
        }
        this.results[chartIndex].tabName = tabNames.join(",");

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if(complianceChart){
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
          this.compliance.setFilters(this.filters.toArray());
          setTimeout(() => { this.setChartStyles(); }, 500);

        }, 500);
      });

      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);

    }, 1000);
  }

  setChartStyles() {
    const textElements = this.el.nativeElement.querySelectorAll('svg g text');
    textElements.forEach((textElement: any) => {
      const textContent = textElement.textContent.trim();
      if (textContent.startsWith('* ')) {
        const parent = textElement.parentNode;
        parent.childNodes.forEach((child) => {
          this.renderer.setAttribute(child, 'style', 'font: bold 11.998px OpenSans-Regular; white-space: pre;');
        })
      }
    });
  }

  initializeFilters() {
    this.selectedSeries.clear();
    this.originalFields = this.fields;
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });
    this.compliance.setFilters(this.filters.toArray());
    this.evaluationService.getSOPEvaluationSeries(this.userID, "Sub-step compliance").subscribe((selectedSeries: any) => {
      if (!selectedSeries || selectedSeries.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      };

      let chartSeries = JSON.parse(selectedSeries.selectedSeries);

      chartSeries.forEach(serie => {
        if(typeof serie === 'number'){
            this.charts.forEach((chart) => {
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
              chart.internalToggleSerie({ index: serie });
            });
        }else{
          let chart = this.charts.find(c => c.chartId === serie.chartId);
          if(!chart) return;
          chart.internalToggleSerie({ index: serie.series });
          this.compliance.toggleVisibility(chart.chartId, {index: serie.series });
          this.filters.forEach((filter, index) => {
            if (index != serie.series) return;
            if (filter.visible == undefined) filter.visible = true;
            filter.visible = !filter.visible;
          });
        }
      });

      this.layoutService.showLoader = false;
    }, (error) => { this.layoutService.showLoader = false; });
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((subSetComplianceArray: any, index) => {
        if (index === 1) {
          if (subSetComplianceArray.isBenchMark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });

      return res.splice(idx, spliceCount);
    }
    return res;
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchMark)
    else
      return res
  }

  shouldHideBenchmarkData() {
    return true;
    // return this.anyWardIsSelected();
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  subSetComplianceStepName(subSetCompliance, translatetext) {
    if (subSetCompliance.stepName.includes(translatetext)) {
      var array = subSetCompliance.stepName.split(" (" + translatetext);
      if (array.length > 1) {
        var trimString = array[0];
        var mainstring = this.layoutService.translateText(trimString).toString();
        subSetCompliance.stepName = subSetCompliance.stepName.replace(trimString, mainstring);
      }
      var string = this.layoutService.translateText(translatetext).toString();
      subSetCompliance.stepName = subSetCompliance.stepName.replace(translatetext, string);
    }
  }

  onSubProcessChange() {
    var newSOP = this.sopDetail.find(res => res.sopid == parseInt(this.selectedSopID));
    if (!this.subProcess) {
      this.compliance.SOPName = newSOP.title + " ( " + this.layoutService.translateText('EVALUATION.WITHOUT_SUB_PROCESS') + " )";
    } else {
      this.compliance.SOPName = newSOP.title;
    }
    this.evaluate(true);
    //this.buildChart(this.apiData);
  }

  onStepLevelFilterChanges(stepTypeValue) {
    if (stepTypeValue === '2') {
      if (this.isSubStepProcessSOP) {
        if (!this.subProcess) {
          this.subProcess = true;
        } else {
          this.subProcess = true;
        }
      } else {
        this.subProcess = false;
      }
      this.stepTypesEnabled = false;
    } else {
      this.stepTypesEnabled = true;
    }
  }

  showFilter(cardType) {
    var showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
      this.userFilters.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  onSopSelectedChange(sop,avoidEvaluation?) {
    if (sop && sop.sopid) {
      this.selectedSopID = sop.sopid.toString();
      this.selectedSopTitle = sop.title;
      this.onSelectedSopSubProcess(0, true);
      this.onSopChange(sop, false);
    } else {
      this.selectedSopID = '';
      this.selectedSopTitle = '';
    }
  }

  onSelectedStepLevelChange(resultSet, stepTypeValue, isManualUpdate = false) {
    resultSet.selectedStepTypeValue = stepTypeValue;
    resultSet.keepColors = true;
    this.setStepTypeNameByValue(resultSet, stepTypeValue);
    if (!isManualUpdate) {
      this.evaluateSingleFilter = resultSet.id;
      this.evaluate(true, resultSet);
    }
  }

  private setStepTypeNameByValue(resultSet, stepTypeValue: any) {
    resultSet.enableSpecificSteps = false;
    resultSet.selectedSpecificStep = [];
    resultSet.selectedSpecificStep.push(this.defaultSpecificStep());
    resultSet.selectedSpecificStepName = this.layoutService.translateText(resultSet.selectedSpecificStep[0].stepTittle);
    switch (stepTypeValue) {
      case 0:
        resultSet.selectedStepTypeName = this.layoutService.translateText('EVALUATION.All.SOP_STEPS');
        resultSet.selectedSpecificStep = this.specificStep;
        break;
      case 1:
        resultSet.selectedStepTypeName = this.layoutService.translateText('EVALUATION.HYGIENE_RELEVANT_STEPS');
        resultSet.selectedSpecificStep = this.specificStep.filter(step => step.hygieneRelevantStep);
        break;
      case 2:
        resultSet.selectedStepTypeName = this.layoutService.translateText('EVALUATION.SPECIFIC_STEPS');
        resultSet.selectedSpecificStep = this.specificStep;
        resultSet.enableSpecificSteps = true;
        break;
    }
  }

  resetFilters() {
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter();
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: "Sub-step compliance",
      selectedSeries: null
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });

  }


  onSeriesClick(serie: any) {

    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "Sub-step compliance",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  async loadFiltersInfo(){
    // need wait for the filter component to be initialized
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if(this.roleId==1){
          filterComponent.setSAFilter(filter, true);
        }else{
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID,'','', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.SubprofessionalCategoryID, true);
          if(filter.multiselect){
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }

      });
    }, 500);
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

  if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  defaultSpecificStep() {
    return { stepTittle: 'EVALUATION.All.SOP_STEPS' };
  }

  defaultMainStep() {
    return { stepName: 'EVALUATION.All.MAIN_STEPS' };
  }


  onSelectedStepChange(resultSet, step, isManualUpdate = false) {
    if(!resultSet.selectedSpecificStep){
      return;
    }
    if (step == 0) {
      resultSet.selectedSpecificStep = this.specificStep;
      resultSet.selectedSpecificStep[0] = this.defaultSpecificStep();
    } else {
      resultSet.selectedSpecificStep = [step];
    }

    resultSet.selectedSpecificStepName = this.layoutService.translateText(resultSet.selectedSpecificStep[0].stepTittle);
    resultSet.keepColors = true;
    if (!isManualUpdate) {
      this.evaluateSingleFilter= resultSet.id;
      this.evaluate(true, resultSet);
    }
  }

  onSelectedSopSubProcess(subProcess, isManualUpdate = false) {
    this.specificStep = [];
    if (subProcess == 0) {
      this.selectedSopSubProcess = this.defaultMainStep();
      this.originalSopSteps.forEach(sopStep => {
        if (sopStep.stepCards.length == 1) {
          this.specificStep = this.specificStep.concat(sopStep.stepCards);
        }
      });
      this.subProcess = false;
      this.onSelectedStepLevelChange({},0, true);
      this.onSelectedStepChange({}, 0, true);
    } else {
      this.selectedSopSubProcess = subProcess;
      this.specificStep = subProcess.stepCards.map(step => ({...step,parentStepId: subProcess.stepId}));
      this.subProcess = true;
    }

    this.selectedSopSubProcessName = this.layoutService.translateText(this.selectedSopSubProcess.stepName);
    if (!isManualUpdate) {
      this.evaluate(true);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }

}
